// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2XvMk","buttons":"RemoveExpirationActionButtons_buttons__2PBNR"};